import styled from 'styled-components'
import { media } from '../../../utils'

export const FakePlanningContainer = styled.div`
  grid-area: slider;
  overflow: hidden;
  margin: -15px 0 -20px 0;

  ${media.giant` margin: 0; `}
`

export default FakePlanningContainer



// WEBPACK FOOTER //
// ./src/components/containers/wizard/FakePlanningSliderContainer.tsx